<template>
    <v-form>
        <v-progress-linear indeterminate v-if="loading"/>
        <v-container grid-list-md>
            <v-layout align-center class="mb-3">
                <div class="headline" v-if="banner.id">Rediger banner-annonse</div>
                <div class="headline" v-else>Ny banner-annonse</div>

                <v-spacer/>

                <v-btn :to="{name: 'Index'}">
                    <v-icon left>arrow_back</v-icon>
                    Tilbake
                </v-btn>
            </v-layout>

            <v-text-field solo v-model="banner.title" label="Annonsørens navn" hide-details required/>

            <v-card class="mt-2 mb-2 px-3 pt-2">
                <v-layout>
                    <v-flex>
                        <v-datetime-picker format="DD.MM.YYYY HH:mm" label="Vis fra" clear-text="Tøm" locale="nb"
                                           :first-day-of-week="1" v-model="banner.show_from"/>
                    </v-flex>
                    <v-flex>
                        <v-datetime-picker format="DD.MM.YYYY HH:mm" label="Vis til (kan stå tom)" clear-text="Tøm"
                                           :first-day-of-week="1" locale="nb" v-model="banner.show_until"/>
                    </v-flex>
                </v-layout>
            </v-card>

            <upload-button title="Velg fil" class="pl-0" :fileChangedCallback="handleFileChange"/>
            <div v-if="banner.image">
                <v-subheader v-if="typeof banner.image.name === 'string'">
                    Valgt fil: {{ banner.image.name }}
                </v-subheader>
                <v-card style="max-width: 400px; max-height: 250px" class="mt-1 text-xs-center" v-else>
                    <img :src="banner.image" style="max-width: 100%; max-height: 200px">
                </v-card>
            </div>

            <v-text-field class="mt-2" solo v-model="banner.url" type="url" label="Lenke" persistent-hint required
                          hint="Lenke som åpnes når man trykker på annonsen"/>

            <v-checkbox label="Er synlig" v-model="banner.is_active" hide-details/>

            <v-divider class="my-3"/>

            <v-btn @click="save" color="green" dark>Lagre</v-btn>
            <v-btn @click="remove" color="red" dark v-if="banner.id">Slett</v-btn>
        </v-container>
    </v-form>
</template>

<script>
    import axios from 'axios';
    import UploadButton from 'vuetify-upload-button';

    export default {
        components: {
            UploadButton
        },

        created() {
            let id = this.$route.params.id;
            if (id) {
                this.loadData(id);
            }
        },

        data() {
            return {
                loading: false,
                banner: {
                    title: '',
                    image: null,
                    is_active: true
                }
            }
        },
        methods: {
            loadData(bannerId) {
                this.loading = false;
                axios.get(`/api/banners/${bannerId}/`).then(response => {
                    this.banner = response.data;
                }).finally(() => {
                    this.loading = false;
                });
            },

            handleFileChange(file) {
                console.log(file)
                this.banner.image = file;
            },

            save() {
                let formData = new FormData();

                formData.append('title', this.banner.title);
                formData.append('url', this.banner.url);
                formData.append('is_active', this.banner.is_active);

                if (this.banner.image && typeof this.banner.image.name === 'string') {
                    formData.append('image', this.banner.image);
                }

                if (this.banner.show_from && typeof this.banner.show_from.getMonth === 'function') {
                    formData.append('show_from', this.banner.show_from.toISOString());
                }
                if (!this.banner.show_until) {
                    formData.append('show_until', '');
                } else if (this.banner.show_until && typeof this.banner.show_until.getMonth === 'function') {
                    formData.append('show_until', this.banner.show_until.toISOString());
                }

                let method;
                let path;
                if (this.banner.id) {
                    method = axios.patch;
                    path = `/api/banners/${this.banner.id}/`;
                } else {
                    method = axios.post;
                    path = '/api/banners/';
                }

                this.loading = true;
                method(path, formData, {
                    headers: {'Content-Type': 'multipart/form-data'}
                }).then(response => {
                    this.banner = response.data;
                    this.$snackbar.success('Lagring vellykket.');
                }).catch(() => {
                    this.$snackbar.error('Lagring feilet.');
                }).finally(() => {
                    this.loading = false;
                });
            },

            remove() {
                let ok = confirm('Vil du slette denne annonsen?');
                if (!ok) return;

                axios.delete(`/api/banners/${this.banner.id}`).then(response => {
                    this.$router.push({name: 'Index'});
                    this.$snackbar.info('Sletting vellykket.');
                });
            }
        }
    }
</script>